import { render } from "./BanobagiHome.vue?vue&type=template&id=5192a1f2&scoped=true"
import script from "./BanobagiHome.vue?vue&type=script&lang=js"
export * from "./BanobagiHome.vue?vue&type=script&lang=js"

import "./BanobagiHome.vue?vue&type=style&index=0&id=5192a1f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5192a1f2"]])

export default __exports__